import { createEntityReducer } from "@selas/state-management";

import Endpoint from "../../services/api/endpoint";
import { IProjectParticipantFollowUpTask } from "../../utils/types/models";

export default createEntityReducer<IProjectParticipantFollowUpTask>(Endpoint.ProjectParticipantFollowUpTasks, Endpoint.ProjectParticipantFollowUpTasksList);
